export default __webpack_public_path__ + "static/media/success.6327cd2f.svg";